import styled from "styled-components";
import { colors } from "../../theme/colors";
import { Box, Grid } from "@mui/material";
import Ticket from "../../assets/card-oky-ebi-1.webp";
import TicketMallBi from "../../assets/newLine/detalles-de-compra.webp";

export const StyledTitle = styled.div`
  color: ${colors.secondary};
  font-size: 30px;
  font-weight: bold;
  text-align: center;

  @media screen and (max-width: 425px) {
    font-size: 24px;
  }
`;

export const StyledProductWrapper = styled(Grid)`
  width: 530px !important;
  max-width: 100%;
  margin: 2rem auto;
  background-image: url(${TicketMallBi});
  background-repeat: no-repeat;
  background-size: contain;
  height: 322px;

  @media screen and (max-width: 450px) {
    height: 225px;
  }
`;

export const ContentWrapper = styled.div`
  margin: 3rem auto;
  max-width: 650px;
  width: 85%;

  @media screen and (max-width: 450px) {
    width: 85%;
  }
`;

export const SectionWrapper = styled.div`
  border: 1px solid #f0f1f1;
  border-radius: 24px;
  padding: 20px 57px;
  margin-bottom: 1rem;

  @media screen and (max-width: 450px) {
    padding: 5%;
  }
`;

export const ModalBox = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 64px 0;
  background-color: ${colors.white.main};
  width: 55vw;
  min-height: 500px;
  max-height: 85vh;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 2rem;

  & > * {
    width: 60%;
    text-align: center;
  }

  @media screen and (max-width: 600px) {
    width: 85vw;

    & > * {
      width: 90%;
      text-align: center;
    }
  }
`;

export const PaymentSectionWrapper = styled.div`
  width: 85%;
  margin: 2rem auto;
  max-width: 812px;

  @media screen and (max-width: 450px) {
    width: 85%;
  }
`;

export const StyledCardAmount = styled.div`
  color: ${colors.white.main};
  margin-top: 2rem;
  font-size: 3rem;
  font-weight: bold;

  @media screen and (max-width: 450px) {
    margin-top: 0;
  }

  @media screen and (max-width: 365px) {
    font-size: 2rem;
  }
`;
